export default "__VITE_ASSET__HUI54wER__"